// @flow
import React, { type Element } from 'react';
import { Track } from 'angieslist-app-platform';
import { Col, Image } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import { CaretRightIcon, StarIcon } from '@angi/icons';
import { UserAvatarIcon32 } from '@angi/icons/design-system-icons/ui-icons/32';
import './miniBusinessCard.scss';

type Props = {
  starRating?: number,
  coverPhotoUrl?: string,
  businessName: string,
  reviewCount?: number,
  profileLink: string,
}

export const MiniBusinessCard = (props: Props): Element<"div"> => {
  const {
    starRating,
    coverPhotoUrl,
    businessName,
    profileLink,
    reviewCount,
  } = props;

  const openProfileLink = () => { window.location.href = profileLink; };

  return (
    <Track>
      <div
        id="mini-business-card-container"
        className="mini-business-card"
        onClick={openProfileLink}
        onKeyDown={openProfileLink}
        role="button"
        tabIndex={0}
      >
        <div id="cover-photo-container" className="center-container">
          <div className="circle">
            <Choose>
              <When condition={coverPhotoUrl}>
                <Image
                  id="cover-photo-img"
                  src={coverPhotoUrl}
                  className="center"
                  alt="68x68"
                />
              </When>
              <Otherwise>
                <UserAvatarIcon32
                  className="cover-photo"
                />
              </Otherwise>
            </Choose>
          </div>
        </div>
        <div id="title-reviews-container" className="center-container">
          <div>
            <div className="title National2-Bold">{businessName}</div>
            <div className="reviews National2-Regular">
              <StarIcon
                className={starRating ? 'star-icon' : 'star-icon star-icon-secondary'}
              />
              <Choose>
                <When condition={starRating}>
                  &nbsp;&nbsp;
                  <b>
                    {
                      (starRating || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 1 },
                      )
                    }
                  </b>
                  <If condition={reviewCount}>
                    &nbsp;({ reviewCount })
                  </If>
                </When>
                <Otherwise>
                  &nbsp;&nbsp;No reviews yet
                </Otherwise>
              </Choose>
            </div>
          </div>
        </div>
        <Col s={2} id="caret-container" className="center-container">
          <CaretRightIcon
            className="caret-icon center-y"
          />
        </Col>
      </div>
    </Track>
  );
};

export default (compose(pure)(MiniBusinessCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/miniBusinessCard.js